import React, { useState, useRef } from 'react';

function ProjelerSection() {
  // State for each accordion panel
  const [isAğırlıkBoyutlarOpen, setIsAğırlıkBoyutlarOpen] = useState(false);
  const [isRenkSecenekleriOpen, setIsRenkSecenekleriOpen] = useState(false);
  const [isIsikUvGecirgenligiOpen, setIsIsikUvGecirgenligiOpen] = useState(false);
  const [isIsiIletimiYalitimazlikOpen, setIsIsiIletimiYalitimazlikOpen] = useState(false);
  const [isRuzgarMukavemetiOpen, setIsRuzgarMukavemetiOpen] = useState(false);
  const [isToleranslarOpen, setIsToleranslarOpen] = useState(false);

  // Refs to get the height of the content for smooth animation
  const ağırlıkBoyutlarRef = useRef(null);
  const renkSecenekleriRef = useRef(null);
  const isikUvGecirgenligiRef = useRef(null);
  const isiIletimiYalitimazlikRef = useRef(null);
  const ruzgarMukavemetiRef = useRef(null);
  const toleranslarRef = useRef(null);

  // Function to toggle accordion panel visibility
  const togglePanel = (panelSetter, currentState) => {
    panelSetter(!currentState);
  };

  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center bg-white p-4 sm:p-8">
      <h2 className="text-2xl sm:text-3xl font-light text-center text-gray-800 mb-8 sm:pb-3">Teknik veriler</h2>

      <div className="w-full max-w-xl lg:max-w-4xl grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
        {/* Left Column */}
        <div className="flex flex-col space-y-4">
          {/* Ağırlık ve boyutlar */}
          <div className="border border-gray-300 rounded">
            <div
              className="flex justify-between items-center cursor-pointer p-1 sm:p-3"
              onClick={() => togglePanel(setIsAğırlıkBoyutlarOpen, isAğırlıkBoyutlarOpen)}
            >
              <span className="text-sm sm:text-md font-light text-gray-700">Ağırlık ve boyutlar</span>
              <span className="text-xl sm:text-2xl font-light text-gray-500">{isAğırlıkBoyutlarOpen ? '-' : '+'}</span>
            </div>
            <div
              ref={ağırlıkBoyutlarRef}
              className={`transition-all duration-300 ease-in-out overflow-hidden`}
              style={{ maxHeight: isAğırlıkBoyutlarOpen ? ağırlıkBoyutlarRef.current.scrollHeight : 0 }}
            >
              <div className="p-3 pt-0 sm:p-4 sm:pt-0 text-gray-600 text-xs sm:text-sm leading-relaxed font-light">
                <p><span className="font-normal">Ağırlık</span> - 40 mm kalınlıkta panelde maksimum 8 kg/m²</p>
                <p><span className="font-normal">Kalınlık (standart)</span> - 40 mm</p>
                <p><span className="font-normal">Kalınlık (opsiyonel)</span> - 60 - 80 mm</p>
                <p><span className="font-normal">Genişlik</span> - Maksimum 1.159 m</p>
                <p><span className="font-normal">Boy</span> - 9.5 m.ye kadar serbest boy</p>
              </div>
            </div>
          </div>

          {/* Renk seçenekleri */}
          <div className="border border-gray-300 rounded">
            <div
              className="flex justify-between items-center cursor-pointer p-1 sm:p-3"
              onClick={() => togglePanel(setIsRenkSecenekleriOpen, isRenkSecenekleriOpen)}
            >
              <span className="text-sm sm:text-md font-light text-gray-700">Renk seçenekleri</span>
              <span className="text-xl sm:text-2xl font-light text-gray-500">{isRenkSecenekleriOpen ? '-' : '+'}</span>
            </div>
            <div
              ref={renkSecenekleriRef}
              className={`transition-all duration-300 ease-in-out overflow-hidden`}
              style={{ maxHeight: isRenkSecenekleriOpen ? renkSecenekleriRef.current.scrollHeight : 0 }}
            >
              <div className="p-3 pt-0 sm:p-4 sm:pt-0 text-gray-600 text-xs sm:text-sm leading-relaxed font-light">
                <p>Tüm <span className="font-normal">RAL®</span> ve <span className="font-normal">Pantone®</span> renklerde üretilebilir.</p>
              </div>
            </div>
          </div>

          {/* Işık ve UV geçirgenliği */}
          <div className="border border-gray-300 rounded">
            <div
              className="flex justify-between items-center cursor-pointer p-1 sm:p-3"
              onClick={() => togglePanel(setIsIsikUvGecirgenligiOpen, isIsikUvGecirgenligiOpen)}
            >
              <span className="text-sm sm:text-md font-light text-gray-700">Işık ve UV geçirgenliği</span>
              <span className="text-xl sm:text-2xl font-light text-gray-500">{isIsikUvGecirgenligiOpen ? '-' : '+'}</span>
            </div>
            <div
              ref={isikUvGecirgenligiRef}
              className={`transition-all duration-300 ease-in-out overflow-hidden`}
              style={{ maxHeight: isIsikUvGecirgenligiOpen ? isikUvGecirgenligiRef.current.scrollHeight : 0 }}
            >
              <div className="p-3 pt-0 sm:p-4 sm:pt-0 text-gray-600 text-xs sm:text-sm leading-relaxed font-light">
                <p><span className="font-normal">Işık geçirgenliği</span></p>
                <ul className="list-disc pl-5 mt-1">
                  <li>EN 410 - Mavi panelde - % 65</li>
                  <li>EN 410 - Yeşil panelde - % 74</li>
                  <li>EN 410 - Renksiz panelde - % 78</li>
                </ul>
                <p className="mt-2"><span className="font-normal">UV geçirgenliği</span></p>
                <ul className="list-disc pl-5 mt-1">
                  <li>300 mm üzeri - % 0</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="flex flex-col space-y-4">
          {/* Isı iletimi ve yanmazlık */}
          <div className="border border-gray-300 rounded">
            <div
              className="flex justify-between items-center cursor-pointer p-1 sm:p-3"
              onClick={() => togglePanel(setIsIsiIletimiYalitimazlikOpen, isIsiIletimiYalitimazlikOpen)}
            >
              <span className="text-sm sm:text-md font-light text-gray-700">Isı iletimi ve yanmazlık</span>
              <span className="text-xl sm:text-2xl font-light text-gray-500">{isIsiIletimiYalitimazlikOpen ? '-' : '+'}</span>
            </div>
            <div
              ref={isiIletimiYalitimazlikRef}
              className={`transition-all duration-300 ease-in-out overflow-hidden`}
              style={{ maxHeight: isIsiIletimiYalitimazlikOpen ? isiIletimiYalitimazlikRef.current.scrollHeight : 0 }}
            >
              <div className="p-3 pt-0 sm:p-4 sm:pt-0 text-gray-600 text-xs sm:text-sm leading-relaxed font-light">
                <p><span className="font-normal">Isı iletim katsayısı</span> - EN ISO 8990 - 2.02 W/m²K</p>
                <p><span className="font-normal">Yanmazlık</span> - EN 13501-1 - Class E</p>
                <p>(isteğe göre daha üst sınıflarda üretim yapılabilir)</p>
              </div>
            </div>
          </div>

          {/* Rüzgar mukavemeti */}
          <div className="border border-gray-300 rounded">
            <div
              className="flex justify-between items-center cursor-pointer p-1 sm:p-3"
              onClick={() => togglePanel(setIsRuzgarMukavemetiOpen, isRuzgarMukavemetiOpen)}
            >
              <span className="text-sm sm:text-md font-light text-gray-700">Rüzgar mukavemeti</span>
              <span className="text-xl sm:text-2xl font-light text-gray-500">{isRuzgarMukavemetiOpen ? '-' : '+'}</span>
            </div>
            <div
              ref={ruzgarMukavemetiRef}
              className={`transition-all duration-300 ease-in-out overflow-hidden`}
              style={{ maxHeight: isRuzgarMukavemetiOpen ? ruzgarMukavemetiRef.current.scrollHeight : 0 }}
            >
              <div className="p-3 pt-0 sm:p-4 sm:pt-0 text-gray-600 text-xs sm:text-sm leading-relaxed font-light">
                <p><span className="font-normal">Rüzgar mukavemeti</span> - EN 12424 - 120 kg/m²</p>
              </div>
            </div>
          </div>

          {/* Toleranslar */}
          <div className="border border-gray-300 rounded">
            <div
              className="flex justify-between items-center cursor-pointer p-1 sm:p-3"
              onClick={() => togglePanel(setIsToleranslarOpen, isToleranslarOpen)}
            >
            <span className="text-sm sm:text-md font-light text-gray-700">Toleranslar</span>
              <span className="text-xl sm:text-2xl font-light text-gray-500">{isToleranslarOpen ? '-' : '+'}</span>
            </div>
            <div
              ref={toleranslarRef}
              className={`transition-all duration-300 ease-in-out overflow-hidden`}
              style={{ maxHeight: isToleranslarOpen ? toleranslarRef.current.scrollHeight : 0 }}
            >
              <div className="p-3 pt-0 sm:p-4 sm:pt-0 text-gray-600 text-xs sm:text-sm leading-relaxed font-light">
                <p><span className="font-normal">Genişlik</span> - ± 1 mm</p>
                <p><span className="font-normal">Uzunluk</span> - ± 2 mm</p>
                <p><span className="font-normal">Kalınlık</span> - ± 0.5 mm</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjelerSection;